/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Log levels (most to least restrictive):
 * - error
 * - warn
 * - info
 * - debug
 *
 * Default log level: 'info' (production), 'debug' (development).
 * Set via useRuntimeConfig().logLevel or setLogLevel().
 * Any other value (e.g. 'off') disables logging.
 */

const LOG_LEVELS = ['error', 'warn', 'info', 'debug'];

let currentLogLevel = process.env.NODE_ENV === 'development' ? 'debug' : 'info';
let currentLogLevelId = LOG_LEVELS.indexOf(currentLogLevel);

function setLogLevel(level: string) {
    currentLogLevel = level;
    currentLogLevelId = LOG_LEVELS.indexOf(level);
}

function getLogLevel() {
    return currentLogLevel;
}

function isLoggingEnabled() {
    return currentLogLevelId !== -1;
}

function shouldLog(level: string) {
    return LOG_LEVELS.indexOf(level) <= currentLogLevelId;
}

function log(...args: any[]) {
    if (!shouldLog('info')) return;
    console.log(...args);
}

function error(...args: any[]) {
    if (!shouldLog('error')) return;
    console.error(...args);
}

function warn(...args: any[]) {
    if (!shouldLog('warn')) return;
    console.warn(...args);
}

function debug(...args: any[]) {
    if (!shouldLog('debug')) return;
    console.debug(...args);
}

const info = log;

export default { log, error, warn, debug, info, getLogLevel, setLogLevel, isLoggingEnabled };
